import React from 'react'
import { Header, Tab } from 'semantic-ui-react'
import Upload from './media/upload'
import List from './media/list'

const renderPanes = ({...props}) => {
  let panes = []
  const permissions = localStorage.getItem('permissions')

  panes.push({menuItem: 'Liste', render: () => <Tab.Pane attached={false}><List {...props} /></Tab.Pane>})
  if (permissions.indexOf('create_media') !== -1) {
    panes.push({menuItem: 'Upload', render: () => <Tab.Pane attached={false}><Upload onDrop={props.onDrop} dropzone={props.dropzone} /></Tab.Pane>})
  }

  return panes
}

const Medias = ({...props}) => {
  return (
    <div>
      <Header as="h1">Médias</Header>
      <Tab menu={{ pointing: true }} panes={renderPanes({...props})} />
    </div>
  )
}

export default Medias



// WEBPACK FOOTER //
// ./src/components/list/Medias.js